import React, { Component } from 'react'
import { Form, Row, Col } from 'react-bootstrap';
import Validator from 'validatorjs';

import { Http } from '../../../support';
import { FormControl } from '../../../facturotopia';
import { TheError, TheResult } from '../../../shared/responses/TheResult';
import LoadingButton from '../../../facturotopia/LoadingButton';

class PacHitsAssignment extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      error: undefined,
      result: undefined,
      validator: new Validator({}, this.rules),
      isValid: false
    };
  }

  get rules() {
    return {
      hits: ['required', 'numeric'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      error: undefined,
      result: undefined,
      data,
      isValid: validator.passes()
    });
  }

  handleSubmit = async (event) => {
    this.setState({
      busy: true
    });

    try {
      const { id } = this.props.data;

      const response = await Http.post(`api/pacs/${id}/hits`, this.state.data);

      this.setState({
        data: {},
        result: response
      });

      this.props.onUpdate(response.data);
    } catch (error) {
      this.setState({
        error: error.data || error
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  render() {
    const { data, isValid, busy, result, error } = this.state;

    return (
      <Form autoComplete="off">

        <Row>
          <Col sm="12" md="6" xl="4">
            <FormControl type="text"
              label="Asignar Hits"
              name="hits"
              placeholder=""
              help="Los hits se sumarán a los que tiene el pac actualmente"
              rules={ this.rules.hits }
              value={ data.hits }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        { !!result && <TheResult result={ result } /> }

        { !!error && <TheError error={ error } /> }

        <Row>
          <Col sm="12" md="6" xl="4">
            <LoadingButton type="button"
              disabled={ !isValid }
              loading={ busy }
              onClick={ this.handleSubmit }
            >
              { busy ? 'Asignando...' : 'Asignar' }
            </LoadingButton>
          </Col>
        </Row>

      </Form>
    )
  }
}

export default PacHitsAssignment;